import { Link } from "react-router-dom";

const stats = [
  { value: "12+", label: "收录影视作品" },
  { value: "36", label: "角色深度分析" },
  { value: "8", label: "最新影视动态" },
  { value: "3", label: "主题策划专题" },
];

export default function StationIntro() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-50 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-information-line text-sm" />
            关于一路向西
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一个认真读剧情的影视内容平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            一路向西影视内容平台专注于影视作品的剧情梳理、角色关系分析与最新影视动态。我们不追求浮夸的标题，而是希望把一部作品的故事脉络、人物动机讲清楚，让每一次阅读都真正有所收获。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            无论是想快速了解一部作品讲了什么，还是想深入分析角色的选择与命运，这里都能为你提供清晰、完整、可读性强的影视资讯。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解站点与联系方式
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="rounded-lg bg-background-100 p-5 text-center">
              <p className="font-heading text-3xl font-extrabold text-accent-600">{stat.value}</p>
              <p className="mt-2 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}